module.exports = __webpack_public_path__ + "img/10887_L.5cd1bb20.png";